import { useLocalStorage } from '@mantine/hooks'

import { TMapSettings } from '../types'
import { defaultValue } from './defaultValue'

export function useMapSettings(): {
  settings: TMapSettings
  setSettings: (obj: Partial<TMapSettings>) => void
} {
  const [settings, setSettingsInternal] = useLocalStorage({
    key: 'MAP_SETTINGS',
    defaultValue,
    getInitialValueInEffect: false,
  })

  const setSettings = (obj: Partial<TMapSettings>): void => {
    setSettingsInternal((previousSettings) => {
      return { ...previousSettings, ...obj }
    })
  }

  return {
    settings: {
      ...defaultValue,
      ...settings,
    },
    setSettings,
  }
}
